<div *ngIf="campaign" class="campaign-container">
  <!-- <div class="menu">
    <div class="menu-item"><a routerLink='./'>Campaign</a></div>
    <div class="menu-item"><a routerLink='deliverables'>Deliverables</a></div>
    <div class="menu-item"><a routerLink='timeline'>Timeline</a></div>
    <div class="menu-item"><a routerLink='files'>Files</a></div>
    <div class="menu-item"><a routerLink='invoices'>Invoices</a></div>
    <div class="menu-item"><a routerLink='reporting'>Reporting</a></div>
    <div class="menu-item"><a routerLink='changes'>AI Changes</a></div>
  </div>
  <hr> -->
  <router-outlet></router-outlet>
</div>
